import { subscribe as i } from "@nextcloud/event-bus";
let r;
const u = [];
function d() {
  if (r === void 0) {
    const e = document?.getElementsByTagName("head")[0];
    r = e ? e.getAttribute("data-requesttoken") : null;
  }
  return r;
}
function c(e) {
  u.push(e);
}
i("csrf-token-update", (e) => {
  r = e.token, u.forEach((t) => {
    try {
      t(r);
    } catch (s) {
      console.error("error updating CSRF token observer", s);
    }
  });
});
let n;
const o = (e, t) => e ? e.getAttribute(t) : null;
function l() {
  if (n !== void 0)
    return n;
  const e = document?.getElementsByTagName("head")[0];
  if (!e)
    return null;
  const t = o(e, "data-user");
  return t === null ? (n = null, n) : (n = {
    uid: t,
    displayName: o(e, "data-user-displayname"),
    isAdmin: !!window._oc_isadmin
  }, n);
}
export {
  l as getCurrentUser,
  d as getRequestToken,
  c as onRequestTokenUpdate
};
